<!-- Application Validation Alerts (bottom of page) -->
<ea-alert
  alertId="alert-{{ page.id }}"
  [showAlert]="
    (workflowPageNavigationService.pageSubmitted$ | async) &&
    ((page.helper.isPageComplete && this.page.saveIsFailed) || !page.helper.isPageComplete || this.page.actionLogicIsFailed)
  "
  alertStatus="error"
  [attr.data-automation-id]="'global-page-alert'"
  class="fs-unmask"
  [ngClass]="{
    'bl-display--block bl-margin-bottom--24':
      (workflowPageNavigationService.pageSubmitted$ | async) &&
      ((page.helper.isPageComplete && this.page.saveIsFailed) || !page.helper.isPageComplete || this.page.actionLogicIsFailed)
  }"
  [heading]="getHeader()"
  [message]="getMessage()"
>
</ea-alert>
